const beatLoaderStyling = {
  display: "block",
  borderColor: "orange",
  marginTop: "5px",
  marginLeft: "5px",
};

export default beatLoaderStyling;
